export default __webpack_public_path__ + "static/media/jica.52500f3d.webp";